import { UserRole } from '@kainos/shared';

export interface DemoUser {
  id: string;
  fullName: string;
  email: string;
  jobTitle: string;
  role: UserRole;
  /** Availability dot in the team panel. */
  status: 'available' | 'busy';
}

export const DEMO_USERS: DemoUser[] = [
  {
    id: 'usr_renata',
    fullName: 'Renata Vidal',
    email: 'renata.vidal@example.com',
    jobTitle: 'PMO Lead',
    role: UserRole.ADMIN,
    status: 'available',
  },
  {
    id: 'usr_daniela',
    fullName: 'Daniela Rojas',
    email: 'daniela.rojas@example.com',
    jobTitle: 'Project Manager',
    role: UserRole.PROJECT_MANAGER,
    status: 'available',
  },
  {
    id: 'usr_felipe',
    fullName: 'Felipe Soto',
    email: 'felipe.soto@example.com',
    jobTitle: 'Ingeniero de terreno',
    role: UserRole.MEMBER,
    status: 'available',
  },
  {
    id: 'usr_camila',
    fullName: 'Camila Araya',
    email: 'camila.araya@example.com',
    jobTitle: 'Supervisora QA',
    role: UserRole.MEMBER,
    status: 'busy',
  },
  {
    id: 'usr_carlos',
    fullName: 'Carlos Muñoz',
    email: 'carlos.munoz@example.com',
    jobTitle: 'Jefe de montaje',
    role: UserRole.MEMBER,
    status: 'available',
  },
];

const BY_ID = new Map(DEMO_USERS.map((user) => [user.id, user]));

export const userById = (id: string): DemoUser | undefined => BY_ID.get(id);
export const userName = (id: string): string => BY_ID.get(id)?.fullName ?? 'Sin asignar';
